import React from 'react';
import { Link } from 'react-router-dom';
import './EventGrid.css';

// Add EventCard component in the same file
const EventCard = ({ event, isAttending, onSelect, onAttend, isCreator }) => (
  <div className="event-card">
    {event.event_banner_url && (
      <div className="event-card-image">
        <img src={event.event_banner_url} alt={event.title} />
      </div>
    )}
    {(event.previewAttendees && event.previewAttendees.length > 0) || (typeof event.attendee_count === 'number') ? (
      <div className="event-avatars">
        {(event.previewAttendees || []).slice(0,3).map((p, idx) => (
          p.avatar_url ? (
            <img
              key={idx}
              className="event-avatar img"
              src={p.avatar_url}
              alt={p.display_name || p.name || p.email || 'attendee'}
              title={p.display_name || p.name || p.email}
            />
          ) : (
            <div key={idx} className="event-avatar" title={p.display_name || p.name || p.email}>
              {(p.initial || p.display_name?.[0] || p.name?.[0] || p.email?.[0] || '?').toUpperCase()}
            </div>
          )
        ))}
        {typeof event.attendee_count === 'number' && event.attendee_count > (event.previewAttendees?.length || 0) && (
          <div className="event-avatar more">+{event.attendee_count - (event.previewAttendees?.length || 0)}</div>
        )}
      </div>
    ) : null}
    <div className="event-card-content">
      <h3>{event.title}</h3>
      <p className="event-date">{new Date(event.date).toLocaleDateString()}</p>
      <p className="event-time">{event.time}</p>
      <p className="event-language">{event.language}</p>
      <div className="event-actions">
        <button onClick={() => onSelect(event)} className="view-details-btn">
          View Details
        </button>
        {!isCreator && (
          <button 
            onClick={() => onAttend(event.id)}
            className={`attend-btn ${isAttending ? 'attending' : ''}`}
          >
            {isAttending ? 'Attending' : 'Attend'}
          </button>
        )}
      </div>
    </div>
  </div>
);

const EventGrid = ({
  allEvents,
  eventAttendance,
  setSelectedEvent,
  handleAttendEvent,
  currentUser
}) => {
  console.log('Current events:', allEvents);

  return (
    <div className="event-grid">
      {allEvents && allEvents.length > 0 ? (
        allEvents.map(event => (
          <EventCard
            key={event.id}
            event={event}
            isAttending={eventAttendance[event.id]}
            onSelect={() => setSelectedEvent(event)}
            onAttend={() => handleAttendEvent(event.id)}
            isCreator={event.created_by === currentUser?.id}
          />
        ))
      ) : (
        <p className="no-events">No upcoming events</p>
      )}
    </div>
  );
};

export default EventGrid;